import { format, parseISO } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import useMsalApi from '../../components/use-msal-api';
import {StructuredListSkeleton, Button } from 'carbon-components-react';
import Employee from '../review/employee';
import DependentsReview from '../review/dependents-review';
import HealthReview from '../review/health-review';
import DisabilityReview from '../review/disability-review';
import BasicLifeReview from '../review/basic-life-review';
import VoluntaryLifeReview from '../review/voluntary-life-review';
import BeneficiariesReview from '../review/beneficiaries-review';
import FsaReview from '../review/fsa-review';
import { PlanType } from '../../components/enums/plan-type';
import SubmitButton from '../../components/form_elements/submit-button';
import FormTextArea from '../../components/form_elements/form-textarea';
import EditModal from '../../components/form_elements/edit-modal';
import * as Yup from 'yup';
import { OptionalBoolean, RequiredString } from '../../components/form_elements/form-validators';
import { buildBeneficiaries, buildDependents } from '../../components/contact-builder';
import { EnrollmentType } from '../../components/enums/enrollment-type';
import AttachmentReview from '../review/attachment-review';
import ClaycoForm from '../../components/form_elements/clayco-form';
import { useDispatch } from 'react-redux';
import { updateEnrollments } from '../../redux/actions/enrollments-actions';
import EventLog from './event-log';
import { formatDate } from '../../components/formatters';

const Submission = () => {
    const [loading, setLoading] = useState(true);
    const [showLog, setShowLog] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const [denying, setDenying] = useState(false);
    const {enrollmentsId} = useParams();
    const [enrollments, setEnrollments] = useState();
    const [unmodified, setUnmodified] = useState();
    const [callApi] = useMsalApi();
    const [totalDeductions, setTotalDeductions] = useState(0);
    const navigate = useNavigate();
    const [changeType, setChangeType] = useState();
    const [lifeEvents, setLifeEvents] = useState();
    const dispatch = useDispatch();

    const addDeduction = (val) => {
        setTotalDeductions(count => count + val);
    }


    const getBenefits = async () => {
        const results = await callApi(`Enrollments/Submitted/${enrollmentsId}`, "GET");
        if(!results.error){
          setEnrollments(results);
          dispatch(updateEnrollments(results));

          await getUnmodified(results);
        }
        setLoading(false);
    }

    const getUnmodified = async (enroll) => {
        let path = `Enrollments/Unmodified/${enroll.employee.id}/${format(parseISO(enroll.effectiveDate), "yyyy-MM-dd")}`;
        const results = await callApi(path, "GET");
        if(!results.error){
            setUnmodified(results);
        }
    };

    const validationSchema = Yup.object().shape({
        message: RequiredString("Required")
    });

    const fileValidation = Yup.object().shape({
      filesNeeded: OptionalBoolean()
    });

    useEffect(() => {
      if(showLog === false){
        navigate("/Admin/PendingSubmissions");
      }
    }, [showLog])

    const onSubmit = async(formData) => {
        setSubmitting(true);

        const frm = validationSchema.cast(formData);
        const params = {
            deniedMessage: frm.message
        }

        const results = await callApi(`Enrollments/${enrollments.id}/decline`, "PATCH", params);
        if(!results.error)
            navigate("/Admin/PendingSubmissions");
        setSubmitting(false);

    }


    const approve = async () => {
        setShowLog(true);

        setSubmitting(true);
        await callApi(`enrollments/${enrollmentsId}/approve`, "PATCH");
        setSubmitting(false);
        //navigate("/Admin/PendingSubmissions");
    }

  

    const getLifeEvents = async () => {
      var results = await callApi("lookup/AllQualifyingEvents", "GET");
      if(!results.error){
          setLifeEvents(results);
      }
    }

    useEffect(() => {
        getLifeEvents();
        getBenefits(); 
    }, [enrollmentsId])

useEffect(() => {
    if (Array.isArray(enrollments)) return;

    setChangeType(getChangeType());
  }, [enrollments]);

const getChangeType = () => {
    switch (enrollments?.enrollmentTypeId) {
      case EnrollmentType.NewHire:
        return "New Hire";
      case EnrollmentType.OpenEnrollment:
        return "Open Enrollment";
        case EnrollmentType.LifeEvent:
          return "Qualifying Life Event";
        case EnrollmentType.BenficiaryChange:
          return "Beneficiary Change";
        default:
        return "Unknown";
    }
  };

    return ( 
        <>
        {loading === false && unmodified && enrollments ?                 
        <>


            <h4 className='mt-3'>{enrollments.employee.firstName} {enrollments.employee.lastName} ({enrollments.employee.id})</h4>
            <hr className='mb-4 mt-1' />
            <div className="mb-4">
                  Effective Date :{" "}
                    {formatDate(enrollments?.effectiveDate)}
                  </div>
            <div className='mb-4'>
              <p className='text-xl text-danger'>
                Reason
              </p>
              <p>{changeType}</p>
              {enrollments?.lifeEventDescription ? (
                <div>
                  <div className="text-md my-2">
                  Reason:{" "}
                    {lifeEvents?.find((s) => s.id === enrollments?.lifeEventId)?.name}
                  </div>
                  <div className="italic pl-2">
                    {enrollments?.lifeEventDescription}
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>
            <Employee modified={enrollments?.employee} unmodified={unmodified?.employee} />
            <DependentsReview modifiedArray={buildDependents(enrollments)} unmodifiedArray={buildDependents(unmodified)} />
            <HealthReview enrollments={enrollments}  title="Medical" modifiedSelections={enrollments.selections} unmodifiedSelections={unmodified.selections} planType={PlanType.Medical} addDeduction={addDeduction} />
            <HealthReview enrollments={enrollments}  title="Dental" modifiedSelections={enrollments.selections} unmodifiedSelections={unmodified.selections} planType={PlanType.Dental} addDeduction={addDeduction} />
            <HealthReview enrollments={enrollments}  title="Vision" modifiedSelections={enrollments.selections} unmodifiedSelections={unmodified.selections} planType={PlanType.Vision} addDeduction={addDeduction} />
            <DisabilityReview enrollments={enrollments}  addDeduction={addDeduction} />
            <HealthReview
              enrollments={enrollments}
              title="Basic Life"
              modifiedSelections={enrollments.selections}
              unmodifiedSelections={unmodified.selections}
              planType={PlanType.BasicLife}
              addDeduction={addDeduction}
            />
            <VoluntaryLifeReview enrollments={enrollments}  modifiedSelections={enrollments.selections} unmodifiedSelections={unmodified.selections} addDeduction={addDeduction} />
            <BeneficiariesReview modifiedArray={buildBeneficiaries(enrollments)} unmodifiedArray={buildBeneficiaries(unmodified)} />
            <FsaReview enrollments={enrollments}  modifiedSelections={enrollments.selections} unmodifiedSelections={unmodified.selections} addDeduction={addDeduction} />
            <ClaycoForm schema={fileValidation}>
            <AttachmentReview 
              modifiedDependents={buildDependents(enrollments)} 
              unmodifiedDependents={buildDependents(unmodified)} 
              modifiedSelections={enrollments.selections}
              unmodifiedSelections={unmodified.selections}
              contacts={enrollments.contacts}
            />
            </ClaycoForm>
            <EventLog show={showLog} setShow={setShowLog} enrollmentId={enrollments.id} />
            <div className='mt-8'>
                <SubmitButton type="button" onClick={approve} submitting={submitting}>Approve benefit selections</SubmitButton>
                <Button type="button" onClick={() => setDenying(true)} disabled={submitting} kind="ghost">Decline benefit selections</Button>
            </div>
            <EditModal 
            title="Decline Benefit Selections"
            schema={validationSchema} 
            show={denying} 
            setShow={setDenying} 
            onSubmit={onSubmit}
            >
                <p className='mb-4'>Are you sure you want to decline?</p>
                <p>
                    If so, please enter instructions and explanation below to the employee. This message will be send directly to the employee via email.
                </p>
                <div className='my-8 mr-8' >
                <FormTextArea label="Instructions and/or explanation" name="message" />
                </div>            
            </EditModal>

        </>
        :<StructuredListSkeleton />
        }
        </>
     );
}
 
export default Submission;